import React from "react";
import { Button, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

/**
 * Sidebar button for opening the Help & Feedback modal.
 *
 * @param {Object} props
 * @param {boolean} props.collapsed - Sidebar collapsed state
 * @param {Function} props.onClick - Open modal handler
 */
const HelpFeedbackButton = ({ collapsed, onClick }) => {
    if (collapsed) {
        return (
            <div style={{ padding: "8px", textAlign: "center" }}>
                <Tooltip title="Help & Feedback" placement="right">
                    <Button
                        type="text"
                        icon={
                            <QuestionCircleOutlined
                                style={{ color: "#FED230", fontSize: 18 }}
                            />
                        }
                        onClick={onClick}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto",
                        }}
                    />
                </Tooltip>
            </div>
        );
    }

    return (
        <div style={{ padding: "8px 16px 16px", textAlign: "center" }}>
            <Button
                onClick={onClick}
                style={{
                    width: "100%",
                    borderRadius: "20px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    color: "#333",
                    fontSize: "14px",
                }}
                icon={<QuestionCircleOutlined style={{ color: "#FED230" }} />}
            >
                Help & Feedback
            </Button>
        </div>
    );
};

export default HelpFeedbackButton;
